import { render, staticRenderFns } from "./addMedicalCase.vue?vue&type=template&id=d0451aba&scoped=true&"
import script from "./addMedicalCase.vue?vue&type=script&lang=js&"
export * from "./addMedicalCase.vue?vue&type=script&lang=js&"
import style0 from "./addMedicalCase.vue?vue&type=style&index=0&id=d0451aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0451aba",
  null
  
)

export default component.exports